import alt             from './../alt';
import AppActions      from './../actions/AppActions';
import setValueByPath  from './../lib/setValueByPath';
import _               from 'lodash';

class AppStore {
    constructor() {
        this.bindListeners({
            handleUpdateState: AppActions.UPDATE_STATE,
            handleUpdateStates: AppActions.UPDATE_STATES
        });
    }

    handleUpdateState({statePath, data, part}) {
        if (statePath) {
            setValueByPath(this, statePath, data, part);
        }
    }

    handleUpdateStates(states) {
        _.each(states, state => {
            setValueByPath(this, state.statePath, state.data, state.part);
        });
    }
}

export default alt.createStore(AppStore, 'AppStore');